import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { LenticMark } from '../LenticMark';
import { EYEBROW } from './Band';
const buyers = ['VP Finance', 'Financial Controller', 'Head of Internal Audit', 'General Counsel & Risk'];
const pilotIncludes = ['One live requisition, up to five candidates', 'Bespoke scenario build for the role', 'Decision record for every participant', 'Governance pack and panel readout'];
export function Contact() {
  return <section id="contact" className="relative w-full scroll-mt-20 overflow-hidden border-b border-mist bg-bone" data-id="element-43" data-mp="78fcjr289pzv">
      <div className="pointer-events-none absolute -bottom-40 -left-32 opacity-[0.12]" data-id="element-44" data-mp="3uf7nmd0k7phi">
        <LenticMark size={520} title={null} data-id="element-45" data-mp="3pgd75hq2ed0k" />
      </div>

      <div className="relative mx-auto grid w-full max-w-6xl gap-14 px-6 py-24 lg:grid-cols-[1.1fr_0.9fr] lg:items-start lg:px-10 lg:py-36" data-id="element-46" data-mp="3pfld4bc48nce">
        <div data-id="element-47" data-mp="2e17pn7l9y9ww">
          <p className={`${EYEBROW} text-teal`} data-id="element-48" data-mp="2e1hl3ap3999z">Get started</p>
          <h2 className="mt-5 max-w-xl font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-49" data-mp="2e3apskg55jfc">
            Run one requisition through Lentic and read the records yourself.
          </h2>

          <div className="mt-10 rounded-2xl border border-ink/15 bg-white/70 p-8" data-id="element-50" data-mp="2j84f6x0go68b">
            <div className="flex flex-wrap items-baseline justify-between gap-3" data-id="element-51" data-mp="2jai9h3nbheet">
              <h3 className="font-display text-2xl font-medium text-ink" data-id="element-52" data-mp="2o5e3g9c46buk">
                Diagnostic pilot
              </h3>
              <p className="font-display text-3xl font-light text-teal" data-id="element-53" data-mp="2e919dacnpvza">
                from £6,500
              </p>
            </div>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-54" data-mp="20ifrnoyxvs2z">
              {pilotIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-55" data-mp="25g7s57dngmis">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-56" data-mp="25ed8dwe470ga" />
                  <span className="text-[15px] leading-snug text-ink" data-id="element-57" data-mp="1qlt58vqyssyu">{item}</span>
                </li>)}
            </ul>
            <p className="mt-6 border-t border-mist pt-5 text-[15px] leading-relaxed text-graphite" data-id="element-58" data-mp="1cdoizn0lambd">
              Billed as a professional service. No security review, no ATS
              integration, no IT dependency. Twelve working days from role spec
              to live assessment.
            </p>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-59" data-mp="xptqo7qhujyt">
            <a href="mailto:hello@lentic.ai?subject=Lentic%20walkthrough" className="inline-flex items-center gap-2 rounded-full bg-teal px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal-deep" data-id="element-60" data-mp="1vcsmyhd9xpw6">
              Book a walkthrough
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="1ld1t8hwjfex5" />
            </a>
            <a href="#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-7 py-4 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-62" data-mp="1gei8gktok96d">
              See what's in a decision record
            </a>
          </div>
        </div>

        <div className="rounded-2xl border border-mist bg-white/70 p-8" data-id="element-63" data-mp="2go8bpuh3zrjm">
          <h3 className="font-display text-xl font-medium text-ink" data-id="element-64" data-mp="2lmt457q4d6xi">
            Who we build for
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-65" data-mp="2qm60qk6slsda">
            {buyers.map(buyer => <li key={buyer} className="flex items-center gap-3 border-b border-mist pb-3 text-base text-ink last:border-0 last:pb-0" data-id="element-66" data-mp="2qjt9fgf5a5nk">
                <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-67" data-mp="30c8s6fy9my9i" />
                {buyer}
              </li>)}
          </ul>
          <p className="mt-6 max-w-[42ch] text-[15px] leading-relaxed text-graphite" data-id="element-68" data-mp="34c9k93eaf7z1">
            Rollout runs with talent acquisition, never over their heads. They
            own the ATS and the candidate experience, and they get lower
            time-to-decision and fewer late-stage failures out of it.
          </p>
        </div>
      </div>
    </section>;
}